function buildId (section) {
  const order = ['country', 'zone', 'state', 'lga', 'sdp', 'name']
  return order
    .filter(key => section[key]) // only keep present fields
    .map(key => `${key}:${section[key]}`)
    .join(':')
}

const LOCATION_KEYS = ['country', 'zone', 'state', 'lga', 'sdp']

function nextKeysFor (key) {
  // NOTE: `name` is only valid immediately after `zone` (zone-level warehouses),
  // and MUST NOT be treated as a delimiter for SDP values (e.g. "holy-name-clinic").
  switch (key) {
    case 'country':
      return ['zone', 'state', 'lga', 'sdp']
    case 'zone':
      return ['name', 'state', 'lga', 'sdp']
    case 'name':
      return ['state', 'lga', 'sdp']
    case 'state':
      return ['lga', 'sdp']
    case 'lga':
      return ['sdp']
    case 'sdp':
    default:
      return []
  }
}

function parseSection (section) {
  if (!section) return { id: '' }

  const parts = section.split('-').filter(Boolean)
  // Special case: origin/destination can be a simple identifier (e.g. "country", "national")
  if (parts.length === 1) {
    return { id: section }
  }

  const result = {}

  // Parse sequentially so that key words inside values don't get mistaken as delimiters.
  for (let i = 0; i < parts.length - 1;) {
    const key = parts[i]
    const isLocationKey = LOCATION_KEYS.includes(key) || key === 'name'
    if (!isLocationKey) {
      i += 1
      continue
    }

    const allowedNext = nextKeysFor(key)
    const valueParts = []
    for (let j = i + 1; j < parts.length; j++) {
      if (allowedNext.includes(parts[j])) {
        break
      }
      valueParts.push(parts[j])
    }

    if (valueParts.length) {
      result[key] = valueParts.join('-')
    }

    // Move i to the next delimiter (if any), otherwise exit.
    const nextIndex = i + 1 + valueParts.length
    if (nextIndex <= i) break
    i = nextIndex
  }

  result.id = buildId(result)
  return result
}

function parseShipmentIdIntoLocationProps (shipmentId) {
  const originPart = shipmentId.split('origin:')[1].split(':destination:')[0]
  const destinationPart = shipmentId.split(':destination:')[1].split(':date:')[0]

  return {
    origin: parseSection(originPart),
    destination: parseSection(destinationPart)
  }
}

module.exports = { parseShipmentIdIntoLocationProps }
